const initialState = () => ({
  currentPageNumber: 1,
  renderedPages: [],
  pageHeight: 0,
  pdfContent: null,
});

let state = initialState();
let scrollInterval = null;
let elementScrollInterval = null;

// Scroll an element into view within the .pdf-viewer container only,
// without propagating scroll to ancestor containers (body, app header, etc.)
function scrollInContainer(element, block = 'center') {
  const container = element.closest('.pdf-viewer') || document.querySelector('.pdf-viewer');
  if (!container) return;
  const elRect = element.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  if (block === 'start') {
    container.scrollTop += elRect.top - containerRect.top;
  } else {
    container.scrollTop += elRect.top - containerRect.top - container.clientHeight / 2 + elRect.height / 2;
  }
}

// Poll for a DOM element inside a page and center it when found.
// Used by scrollToAnnotation — the page scroll
// is already handled by render-annotation-page.
function waitAndScrollTo(selector, maxAttempts = 25, onFound) {
  if (elementScrollInterval) {
    clearInterval(elementScrollInterval);
    elementScrollInterval = null;
  }
  let attempts = 0;
  elementScrollInterval = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      scrollInContainer(element);
      if (onFound) onFound(element);
      clearInterval(elementScrollInterval);
      elementScrollInterval = null;
    } else if (++attempts >= maxAttempts) {
      clearInterval(elementScrollInterval);
      elementScrollInterval = null;
    }
  }, 100);
}

const actions = {
  setCurrentPageNumber({ commit }, pageNumber) {
    commit('SET_CURRENT_PAGE_NUMBER', pageNumber);
  },
  scrollTo({ commit }, { page, annotation, callback }) {
    const targetElement = document.getElementById(`page-${page}`);
    if (!targetElement) return;

    if (!annotation) {
      scrollInContainer(targetElement);
    }

    if (scrollInterval) {
      clearInterval(scrollInterval);
      scrollInterval = null;
    }

    scrollInterval = setInterval(() => {
      if (state.currentPageNumber !== parseInt(page)) {
        // For plain page scroll, manually scroll. For annotations,
        // render-annotation-page handle the page scroll via pdfjs.
        if (!annotation) {
          scrollInContainer(targetElement);
        }
        return;
      }
      if (annotation) {
        let annotationElement = targetElement.querySelector(
          `.pdf-viewer__annotations-layer .annotation-${annotation.id}`,
        );
        if (!annotationElement) return;
        scrollInContainer(annotationElement);
      }
      clearInterval(scrollInterval);
      // Invoke the callback if provided
      if (callback && typeof callback === 'function') {
        callback();
      }
    }, 200);
  },
  scrollToAnnotation({ commit }, { page, annotation }) {
    const applyHighlight = () => {
      document.querySelectorAll(`.annotation-${annotation.id}`).forEach((el) => el.classList.add('selected'));
      const anchor = document.querySelector(`.annotation-anchor-${annotation.id}`);
      if (anchor) anchor.classList.add('selected');
    };
    waitAndScrollTo(`#page-${page} .pdf-viewer__annotations-layer .annotation-${annotation.id}`, 25, applyHighlight);
  },
  setRenderedPages({ commit }, pages) {
    commit('SET_RENDERED_PAGES', pages);
  },
  RESET({ commit }) {
    commit('RESET_STORE');
  },
};

const mutations = {
  SET_CURRENT_PAGE_NUMBER(state, pageNumber) {
    state.currentPageNumber = parseInt(pageNumber);
  },
  SET_RENDERED_PAGES(state, pages) {
    state.renderedPages = pages;
  },
  RESET_STORE(state) {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      scrollInterval = null;
    }
    if (elementScrollInterval) {
      clearInterval(elementScrollInterval);
      elementScrollInterval = null;
    }
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  currentPageNumber: (state) => state.currentPageNumber,
  pageHeight: (state) => state.pageHeight,
};

export const currentDocument = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
